var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("section", { staticClass: "callout__404" }, [
        _c("div", { staticClass: "intro__404" }, [
          _c("h1", { staticClass: "intro__404--mobile" }, [
            _vm._v("Oops! This page is lost in the woods.")
          ]),
          _c("h1", { staticClass: "intro__404--desktop" }, [
            _vm._v("Oops! This page is lost in the wild.")
          ]),
          _c("a", { attrs: { href: "/" } }, [
            _c("button", { staticClass: "btn btn--white" }, [_vm._v("Go home")])
          ])
        ])
      ]),
      _c(
        "section",
        {
          staticClass: "full__video full__video--404",
          attrs: { id: "fluid__404" }
        },
        [
          _c(
            "div",
            { staticClass: "fluid__video splash--404 fluid__video_404" },
            [
              _c("div", { staticClass: "fluid__video_404--mobile" }, [
                _c("iframe", {
                  attrs: {
                    "data-src":
                      "https://media.flixel.com/cinemagraph/02wesokj9lcphjnob2ba?hd=true",
                    allow: "autoplay"
                  }
                })
              ]),
              _c("div", { staticClass: "fluid__video_404--desktop" }, [
                _c("iframe", {
                  attrs: {
                    "data-src":
                      "https://media.flixel.com/cinemagraph/9m3xdkl8nmv3uibgwitm?hd=true",
                    allow: "autoplay"
                  }
                })
              ]),
              _c("div", { staticClass: "credit" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "https://flixel.com/ixhumni/"
                    }
                  },
                  [_vm._v("Alexandre Miguel")]
                )
              ])
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b3aeb0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b3aeb0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = null
// module chunks = 